<script>
import Video from './Video.svelte'
import { fade } from 'svelte/transition'


let showAbout = false

</script>
<h1 class="notranslate">
	darkrooms
</h1>


<div id="footer">
    Find out more at <a href="https://www.darkroomsessions.live" target="__website">darkroomsessions.live</a>
</div>

<button on:click={() =>showAbout=true} id="huh">[?]</button>



<div id="links">
<a href="https://instagram.com/darkroomslondon" target="__insta"><img src='/insta.png'/></a>
<a href="https://www.facebook.com/sharer/sharer.php?u=https://darkrooms.now.sh" target="_blank"><img src='/facebook.png' /></a>
<a href="https://darkroomsessions.typeform.com/to/M5f0rM" title="Leave us a message" target="__typeform" ><img src='/message.png'/></a>
</div>
<Video></Video>

{#if showAbout}
    <div id="about" on:click|preventDefault on:mouseup|preventDefault transition:fade on:click={() => showAbout=false}>
        <div id="inner">
       
        <p>
        <b>Virtual Darkroom</b> is a digital adaptation of <b>Dark Room Sessions</b>, a monthly live immersive music experience based in London where artists play gigs in pitch black rooms. Audiences are unaware of what artists will be playing each night, encouraging the discovery of new music and emerging artists, and most importantly a more meaningful, non-judgemental connection with live music.
        </p>

        <p>
        Unable to host any live music events for a bit, we’ve tried to fill in that gap for all the musically curious. Each video on this platform has been hand-picked by the same people that curate each live session and artists that you will listen to have either played at a <b>Dark Room Session</b> or have potential to do so in the future. 
        </p>

        <p>
        Videos will play in a random order so you’ll listen to new music that wouldn’t necessarily be in any of your Spotify playlists. Added to that you’ll see a <i>blackout curtain</i> so you won't be able to see who's playing until you decide to <i>reveal the artist</i>. The longer you last with the <i>lights off</i>, the closer you’ll get to the feelings and emotions conveyed during our live gigs.
        </p> 


        <div id="inner2">
        <p>My advice? Headphones and eyes closed.<br/><b>Just open your ears.</b></p>


        <p>(And please share with your friends!)</p>

        <p style='color: pink; font-size:6vh;'>❤</p>
        </div>
        </div>

    </div>
{/if}

<style>
	:global(body) {
		background: rgb(0,0,0);
		color: white;
	}

    #about {
        background: rgba(10,10,10,0.85);
        position: fixed;
        top: 0;
        left: 0;
        padding: 5vh 5vw 5vh 5vw;
        text-align: center;
        color: #aaa;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased !important;
        -moz-font-smoothing: antialiased !important;
        text-rendering: optimizelegibility !important;
        letter-spacing: .03em;
        width: 100vw;
        height: 100vh;
        z-index: 10000;
        /* pointer-events: none; */
    }

    
    #about p {
        margin: 0;
        padding: 0;
        margin-bottom: 30px;
    }

    #about b, #about i { 
        color: #ccc;
    }

    #about #inner {
        margin-top: 5vh;
    font-family: sans-serif;
    width: 70%;
    margin-left: 10%;
    text-align: left;
    line-height: 4vh;
    }

     #about #inner2 {
         text-align: center;
     }

    #huh {
        position: fixed;
        left: 4vh;
        top: 4vh;
        opacity :0.2;
        background: transparent;
        font-size: 3vw;
        color: white;
        border :0;
        z-index: 100;
        cursor: pointer;
        transition: all 1s;
    }

    #huh:hover {
        opacity :1.0;
    }
    #links {
        position: fixed;
        right: 5vw;
        top: 5vw;
        width: 4vw;
        z-index: 100;
        

    }
    #links a {
        display: inline-block;
    transition: all 1s;
    opacity: 0.2;
    }

    #links a:hover {
        opacity: 1.0;
        
    }

    #links img {
        width: 4vw;
        margin-bottom: 2vw;
        color: black;

    }

	h1 {
        pointer-events: none;
        cursor: pointer;
        color: black;
        font-size: 10vh;
        text-align: center;
        top: 3vh;
        position: fixed;
        z-index: 1;
        margin: auto;
        width: 100vw;
        opacity: 0.5;
        opacity: 1.0;
        font-family: 'BRRR';
    text-shadow: 0px 0px 6px rgba(255,255,255,0.4);
	}

    #footer {
        /* background: #222; */
        z-index: 1000;
        width:100%;
        bottom:0;
        left: 0;
        position: fixed;
        
        text-align: center;
        padding: 1vh;
        opacity: 0.5;
        font-size: 2vh;
        font-family: arial;
        color: #9e8a8d;
        

    }

    #footer a {
     
        color: rgb(200,200,200);

    }

    a {
        color: rgb(200,200,250);
    }
</style>